module.exports = __webpack_public_path__ + "img/edit-outline.0ae97157.svg";